<template>
  <div class="info_wrap">
    <NavbarHeader activeName=""></NavbarHeader>
    <div class="news_section">
      <p class="news_fon1"><span @click="gotoHome">< 返回新闻资讯</span></p>
      <div class="menu_title">{{newsDetail.newsTitle}}</div>
      <div class="title_time">{{newsDetail.updateTime}} 发布</div>
      <div class="title_chinese" v-html="newsDetail.newsDesc"></div>
    </div>

    <backTop></backTop>
    <footerBar></footerBar>
  </div>
</template>

<script>
  import backTop from "@/components/assembly/backTop.vue";
  import NavbarHeader from "@/components/NavbarHeader/NavbarHeader.vue";
  import footerBar from "@/components/footerBar/footerBar.vue";
  import {
    newsInfobaseapi
  } from "@/api/apilist/commonApi";
  export default {
      name: '',
      components: {
        NavbarHeader, footerBar,
        backTop
      },
      data() {
        return {
          windowWidth: 1200,
          newsDetail: {
            newsTitle: '',
            updateTime: '',
            newsDesc: ''
          }
        }
      },
      activated() {
        this.getnewsInfobaseapi(this.$route.query.newsId);
      },
      methods:{
        gotoHome(){
          this.$router.back();
        },
        getnewsInfobaseapi(newsId) {
          newsInfobaseapi({
            newsId: newsId
          }).then(res => {
            setTimeout(()=>{
              document.documentElement.scrollTop = 0;
            },100)
            this.newsDetail = res.data;
          })
        }
      }
    }
</script>

<style scoped lang="less">
  .info_wrap{background-color: #fff;width: 100%;}
  @media screen and (max-width: 480px){
	  .news_section{
	    width: 100%;
		padding: 20px 15px 40px;
	    background-color: #fff;
	    position: relative;
	    font-size: 16px;
	    .news_fon1{
	      color: #D9BF81;
	      margin: 0px 0 25px;
	      span{
	        cursor: pointer;
	      }
	    }
	    .menu_title{font-size: 20px;font-weight: bold;}
	    .title_time{
	      color: #C2C2C2;
	      line-height: 60px;
	    }
	    .title_chinese{
	      line-height: 35px;
	      font-size: 18px;
	    }
	  }
  }
  @media screen and (min-width: 481px){
	  .news_section{
	    width: 1200px;
	    margin: 0 auto;
	    background-color: #fff;
	    position: relative;
	    font-size: 16px;
      padding-top: 90px;
	    padding-bottom: 100px;
	    padding-right: 120px;
	    .news_fon1{
	      color: #D9BF81;
	      margin: 0px 0 45px;
	      span{
	        cursor: pointer;
	      }
	    }
	    .menu_title{font-size: 20px;font-weight: bold;}
	    .title_time{
	      color: #C2C2C2;
	      line-height: 60px;
	    }
	    .title_chinese{
	      line-height: 35px;
	      font-size: 18px;
	    }
	  }
  }
</style>
